"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
exports.__esModule = true;
exports.parse = void 0;
var types_1 = require("../types");
var const_1 = require("./const");
var utils_1 = require("./utils");
// Returns the tokens using postfix notation
var parse = function (expression) {
    if (typeof expression !== 'string') {
        throw new Error("Expected string but received ".concat(typeof expression));
    }
    // getNextToken keeps track of the remaining expression
    // and return the next token each time it is called
    var getNextToken = (0, utils_1.newTokenGenerator)(expression);
    return parseInternal(getNextToken);
};
exports.parse = parse;
// parseInternal will recurse over bracketed expressions
var parseInternal = function (getNextToken, nested) {
    if (nested === void 0) { nested = false; }
    // This initialises the output with everything up the first unnested operator
    var output = __spreadArray([], (0, utils_1.getValue)(getNextToken, parseInternal), true);
    var operators = [];
    while (true) {
        var validTokens = nested
            ? const_1.VALID_TOKENS.binaryOperatorOrClose
            : const_1.VALID_TOKENS.binaryOperator;
        // Retrieves the next Token
        var nextToken = getNextToken(validTokens, !nested);
        if (nextToken.name === types_1.Tokens.EOF || // If the end of file is found here then return what we have
            nextToken.name === types_1.Tokens.STRUCTURAL_CHARACTER // The expression will be returned and incorporated into the final expression
        ) {
            return __spreadArray(__spreadArray([], output, true), __spreadArray([], operators, true).reverse(), true);
        }
        // In postfix notation operator order is determined by precedence
        while (operators.length) {
            var previousOperator = operators[operators.length - 1] || null;
            if (previousOperator &&
                (0, utils_1.previousOperatorTakesPrecedent)(previousOperator.value, nextToken.value)) {
                output = __spreadArray(__spreadArray([], output, true), [previousOperator], false);
                operators = operators.slice(0, -1);
            }
            else {
                break;
            }
        }
        // The new operator is now added to the stack
        operators = __spreadArray(__spreadArray([], operators, true), [nextToken], false);
        // Once this is done we can get everything until the next unnested
        // operator and add it to the output
        output = __spreadArray(__spreadArray([], output, true), (0, utils_1.getValue)(getNextToken, parseInternal), true);
    }
};
